import { CHANGE_FILTER_REVENUE_LEAKAGE } from "../constants";

// revenue leakage
export const changeFilterRevenueLeakage = (revenueSortValue) => ({
  type: CHANGE_FILTER_REVENUE_LEAKAGE,
  payload: { revenueSortValue },
});
